import React from 'react';
import { Router } from 'react-router';
import history from 'tradera-utils/history';
import { hot } from 'react-hot-loader';
import ApplicationErrorBoundary from 'tradera-components/application-error-boundary';
import { ProviderWithGlobalStore } from 'tradera-state/configure-store';
import { GeneralError } from 'tradera-components/errors';
import PageHead from 'tradera-components/page-head/page-head';
import SiteHeader from 'tradera-components/site-header/site-header';
import SiteFooter from 'tradera-components/site-footer/site-footer';
import GdprContainer from 'tradera-components/alerts/gdpr/gpdr-container';

import { Routes } from './routes-map';
import './app.scss';

const headerElement = document.querySelector('[data-site-header-slim]');

// Full SPA app with header, footer & everything
function App() {
    const cartItemCount = headerElement?.getAttribute('data-cart-item-count');
    const cartSum = headerElement?.getAttribute('data-cart-sum');
    return (
        // TODO: Replace with general error fallback, move ShowItemsError to discover error boundary
        <ApplicationErrorBoundary fallback={<GeneralError />}>
            <ProviderWithGlobalStore>
                <PageHead />
                <Router history={history}>
                    <SiteHeader
                        inSPA={true}
                        cartItems={cartItemCount}
                        cartSum={cartSum}
                    />
                    <div className="site-main" id="site-main">
                        <Routes />
                    </div>
                    <SiteFooter />
                    <GdprContainer />
                </Router>
            </ProviderWithGlobalStore>
        </ApplicationErrorBoundary>
    );
}

// Basic app without header, footer & other stuff, for old React pages & native app web views
function BasicApp() {
    return (
        <ApplicationErrorBoundary fallback={<GeneralError />}>
            <ProviderWithGlobalStore>
                <Router history={history}>
                    <div>
                        <Routes />
                    </div>
                </Router>
            </ProviderWithGlobalStore>
        </ApplicationErrorBoundary>
    );
}

export default hot(module)(App);
export { App, BasicApp };
